/* eslint-disable no-unused-vars */
import { useState } from "react";
import { useWebWidgetConfig } from "../web-widget/use-web-widget-config";
import { getHSLAString } from "@aichat/aichat-lib";
import { X } from "lucide-react";
import { Button } from "../button";

const greetings: string[] = [
  "Hi there! 👋 How can I help you today?",
  "Hello! 😊 Let me know what you need assistance with.",
  "Hey! ✨ Need some help? I'm here for you.",
  "Hi! 🌟 How's your day going? What can I do for you?",
  "Hello there! 💬 How can I make your day easier?",
  "Hey! 🚀 Ready to get started? Let's do this together!",
];

function getRandomGreeting(): string {
  const randomIndex = Math.floor(Math.random() * greetings.length);
  return (greetings[randomIndex] as string) ?? greetings[0];
}

type WelcomeThemeProps = {
  onOpenChat: (open: boolean) => void;
  onCloseWelcome: () => void;
};

const WelcomeTheme = ({ onOpenChat, onCloseWelcome }: WelcomeThemeProps) => {
  const [greeting, _setGreeting] = useState(getRandomGreeting());
  const { brandColor, isThemeSleek } = useWebWidgetConfig();
  const brandColorHSLA = getHSLAString(brandColor);
  if (isThemeSleek)
    return (
      <div
        className="bg-white p-3 animate-scale-up-right duration-300 delay-500 fill-mode-forwards fixed scale-0 bottom-4 right-14 max-w-[250px] sm:max-w-[520px] cursor-pointer rounded-l-full"
        style={{
          boxShadow: `${brandColorHSLA} 0px 0px 4px 0px`,
          border: `1px solid ${brandColorHSLA}`,
        }}
      >
        <div className="absolute -left-4 -top-4" onClick={onCloseWelcome}>
          <Button
            variant="ghost"
            size="icon"
            className="shadow-md rounded-full size-8 bg-white"
          >
            <X className="size-4 text-secondary-foreground" />
          </Button>
        </div>
        <div
          className="overflow-hidden text-sm whitespace-nowrap text-ellipsis pr-1"
          onClick={() => onOpenChat(true)}
        >
          {greeting}
        </div>
      </div>
    );
  return (
    <div
      className="bg-white rounded-xl rounded-br-none p-4 animate-scale-up-right duration-300 delay-500 fill-mode-forwards fixed scale-0 bottom-16 right-16 max-w-[250px] cursor-pointer"
      style={{
        boxShadow: "rgba(0, 18, 46, 0.16) 0px 8px 26px 0px",
      }}
    >
      <div className="absolute -right-4 -top-4" onClick={onCloseWelcome}>
        <Button
          variant="ghost"
          size="icon"
          className="shadow-md rounded-full size-8 bg-white"
        >
          <X className="size-4 text-secondary-foreground" />
        </Button>
      </div>
      <div
        onClick={() => onOpenChat(true)}
        className="max-h-[150px] overflow-auto text-sm"
      >
        {greeting}
      </div>
    </div>
  );
};

export default WelcomeTheme;
